import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { WA_NUMBER_1, WA_NUMBER_2, WA_BOOK_MSG, waLink, trackEvent } from "@/data/content";

const FloatingWhatsApp = () => {
  const [number] = useState(() => (Math.random() < 0.5 ? WA_NUMBER_1 : WA_NUMBER_2));

  return (
    <a
      href={waLink(number, WA_BOOK_MSG)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent("whatsapp_click", { source: "floating", number })}
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with IQMIZE on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 rounded-full bg-[#25D366] px-5 py-4 text-white shadow-[0_12px_30px_rgb(37,211,102,0.4)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgb(37,211,102,0.5)]"
    >
      <MessageCircle size={24} strokeWidth={2} />
      <span className="hidden sm:inline text-sm font-extrabold">WhatsApp Us</span>
    </a>
  );
};

export default FloatingWhatsApp;
